import React, { Component } from "react";
import {
  Container,
  Grid,
  Form,
  Button,
  Dimmer,
  Loader
} from "semantic-ui-react";
import Heading from "../../components/Header";
import { Redirect } from "react-router-dom";
import fire from "../../config/config";

export default class Support extends Component {
  state = {
    fullname: "",
    email: "",
    tel: "",
    msg: "",
    loading: false,
    redirect: false
  };

  send(e) {
    const { fullname, email, tel, msg } = this.state;
    e.preventDefault();
    this.setState({ loading: true });
    fire
      .database()
      .ref("/support")
      .push({
        fullname,
        email,
        tel,
        msg
      })
      .then(r => this.setState({ loading: false, redirect: true }));
  }

  render() {
    const { loading, redirect } = this.state;

    if (redirect) {
      return <Redirect to="/dashboard" />;
    }

    if (loading) {
      return (
        <Dimmer active inverted>
          <Loader size="large">Loading</Loader>
        </Dimmer>
      );
    }

    return (
      <Container>
        <Grid>
          <Grid.Row style={{ marginBottom: 60 }}>
            <Heading />
          </Grid.Row>
          <Grid.Row centered>
            <Grid.Column width={10}>
              <Form onSubmit={e => this.send(e)}>
                <Form.Field>
                  <label>Full Name</label>
                  <input
                    placeholder="eg. John Doe"
                    onChange={i => this.setState({ fullname: i.target.value })}
                  />
                </Form.Field>
                <Form.Field>
                  <label>Phone Number</label>
                  <input
                    type="tel"
                    placeholder="eg. +63 489 489 4340"
                    onChange={i => this.setState({ tel: i.target.value })}
                  />
                </Form.Field>
                <Form.Field>
                  <label>Email</label>
                  <input
                    onChange={i => this.setState({ email: i.target.value })}
                    placeholder="eg. johndoe@gmail.com"
                    type="email"
                  />
                </Form.Field>
                <Form.TextArea
                  label="Message"
                  placeholder="Let us know how we can help!"
                  onChange={msg => this.setState({msg: msg.target.value}) }
                />
                <Button type="submit">Send Message</Button>
              </Form>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Support/Support.js